module.exports = __webpack_public_path__ + "img/家庭圈信息.95966674.png";